module.exports = __webpack_public_path__ + "img/carlos.f012e556.png";